import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ISetpointModel } from '@caslink/device-client/ng-app/shared/models/models';

interface RtuSetpointEditorPopupData {
    areaId: number;
    locationId: number;
    hardwareItemId: number;
    setpoint: ISetpointModel;
}

// tslint:disable jsdoc-format
@Component({
    selector: 'dl-edit-setpoint-popup',
    template: `
        <popup-header text="{{ data.setpoint.name ? 'Edit' : 'New' }}" (clickAction)="close()"></popup-header>

        <div mat-dialog-content>
            <dl-rtu-setpoint-editor [areaId]="data.areaId"
                                 (cancelSetpointEditor)="close()"
                                 [currentSetpoint]="data.setpoint"
                                 [hardwareItemId]="data.hardwareItemId"
                                 [locationId]="data.locationId"
                                 [override]="false"
                                 [isDialog]="true"
                                 (onSave)="save($event)"></dl-rtu-setpoint-editor>
        </div>
    `,
    styles: [
            `
        div[mat-dialog-content] {
          padding: 20px;

        }
        `
    ]
})
export class RtuSetpointEditorPopupComponent {
    public static $name: string = 'editSetpointPopup';

    constructor(
        private dialogRef: MatDialogRef<RtuSetpointEditorPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: RtuSetpointEditorPopupData
    ) {
    }

    public close() {
        this.dialogRef.close();
    }

    public save(setpoint: ISetpointModel) {
        this.dialogRef.close(setpoint);
    }
}
